import { AssetReference } from '@opallabs/cassini'
import { ModularComponentBuilder } from '../../../../ModularComponentBuilder/index'
import {
  Module,
  ModuleDefinition,
  OnAddSectionProps,
  GetContentByIDV2Return,
  LinkWithData,
  OnShowAssetPickerProps,
  OnLinkDataUpdate,
} from '../../../helpers/types'
import getThreadModule from './getThreadModule'

export type ThreadStreamProps = {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  availableModules: ModuleDefinition[]
  display: string
  getContentByIdV2?: (id: number) => Promise<GetContentByIDV2Return>
  isAccountPremium?: boolean
  isPresenting: boolean
  linksWithData: LinkWithData[]
  modules: Module[]
  onAddSection: (args: OnAddSectionProps) => void
  onDeleteSection: (indexToRemove: number) => void
  onExpandAsset: (assetId: number) => void
  onRemoveAsset: (assetId: number, index: number) => void
  onShowAssetPicker: (args: OnShowAssetPickerProps) => void
  postType: string
  readOnly: boolean
  systemScheduledAt: string
  timezone: string
  updateCoverAsset: (
    assetData: FileList,
    assetId: number,
    index: number
  ) => void
  updateLinkData: OnLinkDataUpdate
  updateSectionPostOption: (index: number, value: string, name: string) => void
  uploadAssets: (assets: FileList, args: OnShowAssetPickerProps) => void
}

export const Stream: React.FC<ThreadStreamProps> = ({
  accountImage,
  accountName,
  accountUsername,
  availableModules,
  display,
  getContentByIdV2,
  isAccountPremium,
  isPresenting,
  modules,
  linksWithData,
  onAddSection,
  onDeleteSection,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  postType,
  readOnly,
  systemScheduledAt,
  timezone,
  updateCoverAsset,
  updateLinkData,
  updateSectionPostOption,
  uploadAssets,
}) => {
  return (
    <ModularComponentBuilder
      modules={modules}
      addComponentText="Add Post"
      availableModules={availableModules}
      allProps={{
        accountImage,
        accountName,
        accountUsername,
        display,
        isAccountPremium,
        isPresenting,
        isThreaded: true,
        readOnly,
        linksWithData,
        systemScheduledAt,
        timezone,
        postType,
      }}
      getContentByIdV2={getContentByIdV2}
      getModule={getThreadModule}
      onExpandAsset={onExpandAsset}
      onRemoveAsset={onRemoveAsset}
      onAddSection={onAddSection}
      onDeleteSection={onDeleteSection}
      onShowAssetPicker={onShowAssetPicker}
      updateCoverAsset={updateCoverAsset}
      updateLinkData={updateLinkData}
      updateSectionPostOption={updateSectionPostOption}
      uploadAssets={uploadAssets}
      width={display.includes('desktop') ? 600 : 375}
    />
  )
}
